module.exports = __webpack_public_path__ + "media/images/roku/header-fd8ac6d268a59040a31a9c53284b3e88.png";